import {
  FormattedMessage,
  messages as prettyPricingMessages,
  prettyPricingMode,
  type PricingModeEnum,
} from '@talos/kyoko';
import { InspectorText } from './InspectorText';

type MessageKey = keyof typeof prettyPricingMessages;

function isPrettyPricingMessageKey(key: string): key is MessageKey {
  return key in prettyPricingMessages;
}

interface PricingModeDisplayProps {
  pricingMode: PricingModeEnum;
}

export const PricingModeDisplay = ({ pricingMode }: PricingModeDisplayProps) => {
  const result = prettyPricingMode(pricingMode);
  return (
    <InspectorText>
      {isPrettyPricingMessageKey(result) ? <FormattedMessage {...prettyPricingMessages[result]} /> : result}
    </InspectorText>
  );
};
